import { render, staticRenderFns } from "./MenuBlockquoteButton.vue?vue&type=template&id=2b63f332&"
import script from "./MenuBlockquoteButton.vue?vue&type=script&lang=ts&"
export * from "./MenuBlockquoteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports